<div class="splitAreaContent" #splitAreaContent>
  <div
    *ngIf="isMobileWidth()"
    [ngClass]="[tab.menu_type !== 'Window' ? 'process-report-window' : '', 'close icon-ico-close']"
    (click)="closeInMobile($event)"
  ></div>
  <div class="tab-split-view-content-blade-content" #contentParent><ng-template #content></ng-template></div>
</div>
